import { render, staticRenderFns } from "./RelationshipCard.vue?vue&type=template&id=5af0c765&scoped=true&"
import script from "./RelationshipCard.vue?vue&type=script&lang=js&"
export * from "./RelationshipCard.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RelationshipCard.vue?vue&type=style&index=1&id=5af0c765&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af0c765",
  null
  
)

export default component.exports
import {QCard,QCardSection,QToolbar,QToolbarTitle,QBtn,QTooltip,QTabs,QTab,QItem,QItemLabel,QBadge,QInnerLoading,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QToolbar,QToolbarTitle,QBtn,QTooltip,QTabs,QTab,QItem,QItemLabel,QBadge,QInnerLoading,QSpinnerGears,QField}, component.options.components || {})
